export default "__VITE_ASSET__DPZCU9sI__"